import * as Sentry from "@sentry/browser";
import { CaptureConsole } from "@sentry/integrations";

Sentry.init({
    dsn: "https://7363894271784a978de7f4e11b0640bd@o4504492247941120.ingest.sentry.io/4504971543642112",
    integrations: [
        new Sentry.BrowserTracing(),
        new CaptureConsole({
            levels: ["error"],
        }),
        new Sentry.Replay({
            maskAllInputs: false,
            maskAllText: false,
            blockAllMedia: false,
        }),
        Sentry.browserTracingIntegration(),
    ],
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 0.05,
    tracePropagationTargets: [new RegExp(`^${window.appContext?.Brand?.url}/`)],
    denyUrls: [
        /^https?:\/\/(?:[^.\/]+\.)?sptpub\.com/i,
        /^https?:\/\/(?:[^.\/]+\.)?ui\.invisiblesport\.com/i,
        /webkit-masked-url:\/\/hidden\//i,
        /extensions\//i,
        /^chrome:\/\//i,
        /^chrome-extension:\/\//i,
        /cdn.livechatinc.com/i,
        /^webpack:\/\//i,
    ],
    beforeSend: (error, hint) => {
        return shouldIgnoreError(error) ? null : error;
    },
    ignoreErrors: [
        "ResizeObserver loop limit exceeded",
        "EventHandlerDoesNotExist",
        "Failed to fetch",
        "NetworkError when attempting to fetch resource.",
        "Load failed",
    ],
});

if (window.appContext?.Player?.uuid && window.appContext?.Player?.email) {
    Sentry.setUser({
        id: window.appContext.Player.uuid,
        email: window.appContext.Player.email,
    });
}

Sentry.setTag("brand", window.appContext.Brand.name);

function shouldIgnoreError(error) {
    const exception = error.exception?.values?.[0];
    const now = Date.now();
    if (
        error &&
        error.name === "AbortError" &&
        error.message?.includes("The play() request was interrupted")
    ) {
        console.log("AbortError catched, no Sentry");
        return true;
    }

    if (!error.breadcrumbs) {
        return false;
    }

    // We go from the back since the last breadcrumb is most likely the erroneous one
    for (let i = error.breadcrumbs.length - 1; i >= 0; i--) {
        const breadcrumb = error.breadcrumbs[i];
        if (!breadcrumb) continue;

        // We only need to check the last 5s of breadcrumbs as any earlier breadcrumbs are definitely unrelated
        if (breadcrumb.timestamp && now - breadcrumb.timestamp * 1000 > 5000) {
            break;
        }

        if (isErroneousBreadcrumb(breadcrumb)) {
            return true;
        }
    }

    return false;
}

function isErroneousBreadcrumb(breadcrumb) {
    if (
        breadcrumb.level !== "error" ||
        (breadcrumb.category !== "xhr" && breadcrumb.category !== "fetch")
    ) {
        return false;
    }

    const url = breadcrumb.data?.url;
    if (!url) {
        return false;
    }

    return url.includes("livewire") || url.includes("invisiblesport");
}
